import React from 'react';

import { Tag } from 'antd';
import moment from 'moment'

const channelFilters = [
  {
    text: 'Call',
    value: 'Call',
  },
  {
    text: 'In App Notification',
    value: 'In App Notification',
  },
  {
    text: 'Line',
    value: 'Line',
  },
  {
    text: 'Line Cron',
    value: 'Line Cron',
  },
  {
    text: 'Note',
    value: 'Note',
  },
]

const statusFilter = [
  { text: 'ติดต่อไม่ได้', value: 'ติดต่อไม่ได้' },
  { text: 'นัดติดตาม', value: 'นัดติดตาม' },
  { text: 'ปิดเครื่อง', value: 'ปิดเครื่อง' },
  { text: 'ไม่มีสิทธิ', value: 'ไม่มีสิทธิ' },
  { text: 'ไม่รับสาย', value: 'ไม่รับสาย' },
  { text: 'ไม่สนใจ', value: 'ไม่สนใจ' },
  { text: 'สนใจ', value: 'สนใจ' },
  { text: 'อื่นๆ', value: 'อื่นๆ' }
]

const categoryFilter = [
  { text: 'การตลาด', value: 'การตลาด' },
  { text: 'ติดตามทวงถาม', value: 'ติดตามทวงถาม' },
  { text: 'ทำแผนปลดหนี้', value: 'ทำแผนปลดหนี้' },
  { text: 'ประกาศ', value: 'ประกาศ' },
  { text: 'ปัญหาสินเชื่อ', value: 'ปัญหาสินเชื่อ' },
  { text: 'ปัญหาหนี้', value: 'ปัญหาหนี้' },
  { text: 'ปัญหาแอปพลิเคชัน', value: 'ปัญหาแอปพลิเคชัน' },
  { text: 'เปลี่ยนแปลงข้อมูล', value: 'เปลี่ยนแปลงข้อมูล' },
  { text: 'ไม่ใช่เบอร์ผู้ติดต่อ', value: 'ไม่ใช่เบอร์ผู้ติดต่อ' },
  { text: 'ยืนยันเบอร์ผู้ติดต่อ', value: 'ยืนยันเบอร์ผู้ติดต่อ' },
  { text: 'รายละเอียดสินเชื่อ', value: 'รายละเอียดสินเชื่อ' },
  { text: 'สอบถามข้อมูล', value: 'สอบถามข้อมูล' },
  { text: 'อื่นๆ', value: 'อื่นๆ' }
]

const generateColumns = ({ tags }) => [
  {
    title: 'ช่องทาง',
    dataIndex: 'channel',
    key: 'channel',
    filters: channelFilters,
    onFilter: (value, record) => value === record.channel,
  },
  {
    title: 'วันที่',
    dataIndex: 'datetime',
    key: 'datetime',
    render: (_, record) => (moment(record.created_at).format('DD-MM-YYYY HH:mm')),
  },
  {
    title: 'ข้อความ',
    dataIndex: 'message',
    key: 'message',
    render: (value) => (typeof (value) === 'object' ? JSON.stringify(value, null, 4) : value),
  },
  {
    title: 'สถานะ',
    dataIndex: 'status',
    key: 'status',
    filters: statusFilter,
    onFilter: (value, record) => value === record.status,
  },
  {
    title: 'ประเภท',
    dataIndex: 'category',
    key: 'category',
    filters: categoryFilter,
    onFilter: (value, record) => value === record.category,
  },
  {
    title: 'Tag',
    dataIndex: 'tag',
    key: 'tag',
    filters: generateFilter(tags),
    filterSearch: true,
    onFilter: (value, record) => value === record.tag,
    render: (tag, record) => <Tag color={record.tag_color}>{tag}</Tag>,
  }
];

const generateFilter = (arr) => (arr.map((val) => ({ text: val, value: val })))

export { generateColumns, channelFilters, statusFilter, categoryFilter, generateFilter }
